import { Component, EventEmitter, Input, Output } from '@angular/core';
import { OverlayComponent } from '@overlays/overlay/overlay.component';
import { DomainRole } from '@services/genesys-cloud-user.interface';
import { NgStyle, NgTemplateOutlet } from '@angular/common';

@Component({
  selector: 'app-boost-your-knowledge-overlay',
  templateUrl: './boost-your-knowledge-overlay.component.html',
  styleUrls: ['./boost-your-knowledge-overlay.component.scss'],
  imports: [NgStyle, NgTemplateOutlet],
})
export class BoostYourKnowledgeOverlayComponent extends OverlayComponent {
  @Input() role: DomainRole;
  @Output() readonly linkClick = new EventEmitter<boolean>();

  /**
   * Emit link click event to parent
   */
  override onLinkClick(): void {
    console.log('Boost Your Knowledge Link clicked');
    this.linkClick.emit(true);
  }

  /**
   * Update the overlay styles based on the viewport size
   */
  override updateOverlayStyles(): void {
    const { playerWidth = 0, playerHeight = 0, browserHeight = 0, browserWidth = 0 } = this.viewportSize || {};

    // Calculate dimensions and position
    let overlayWidth: number | string;
    let leftPosition: number | string;
    let topPosition: number | string;
    let calcHeight: number | string;
    let calcPadding: number | string;
    let calcFontSize: number | string;

    // NOTE: Check if browser height is really big or when the
    // browser winodw is narrow. Adjust the overlay to mat
    // the smaller player height and widths.
    if (browserHeight > browserWidth) {
      overlayWidth = Math.floor(playerWidth * 0.75);
      leftPosition = Math.floor((browserWidth - overlayWidth) * 0.333);
      topPosition = Math.floor(playerHeight * 0.45);
      calcHeight = 'fit-content';
      calcFontSize = `3vw`;
      calcPadding = `2vh`;
    } else {
      overlayWidth = Math.floor(browserWidth * 0.85);
      leftPosition = Math.floor((browserWidth - overlayWidth) * 0.25);
      topPosition = Math.floor(playerHeight * 0.6);
      calcHeight = 'fit-content';
      calcFontSize = `4vw`;
      calcPadding = `3vh`;
    }

    this.overlayStyles = {
      position: 'absolute',
      top: `${topPosition}px`,
      left: `${leftPosition}px`,
      width: `${overlayWidth}px`,
      height: `${calcHeight}`,
      fontSize: calcFontSize,
      padding: `${calcPadding}`,
    };
  }
}
